import { format } from 'date-fns/format';
import { parseISO } from 'date-fns/parseISO';
function getContextualAriaLabel({
  ariaLabel,
  endDate,
  isDateFocusable,
  price,
  startDate
}) {
  // Only the Day that can be focused needs the verbose label because it's the only one that
  // will be read by screen readers.
  if (!isDateFocusable) {
    return ariaLabel;
  }
  const readableStart = startDate ? format(parseISO(startDate.toString()), 'PP') : '';
  const readableEnd = endDate ? format(parseISO(endDate.toString()), 'PP') : '';
  const departStr = startDate ? `Depart ${readableStart}` : '';
  const returnStr = endDate ? `Return ${readableEnd}` : '';
  const priceStr = price ? `. Price $${price}` : '';
  const endDateLabel = `${departStr}${returnStr ? `, ${returnStr}` : ''}`;
  return endDateLabel ? `${endDateLabel}${priceStr}. Use arrow keys to change.` : ariaLabel;
}
export default getContextualAriaLabel;